import * as React from 'react';
import { Typography } from '@mui/material';
import classes from './GameStat.module.css';
var GameStat = function (_a) {
    var title = _a.title, cn = _a.cn, game = _a.game;
    var classType = cn === 'audio' ? classes.audio : classes.sprint;
    return (React.createElement("section", { className: classes.section },
        React.createElement(Typography, { className: classType, variant: "h4", component: "h4" }, title),
        React.createElement("div", { className: classes.rows },
            React.createElement("p", null, game ? game.newWords : 0),
            React.createElement("p", null, "\u041D\u043E\u0432\u044B\u0435 \u0441\u043B\u043E\u0432\u0430")),
        React.createElement("div", { className: classes.rows },
            React.createElement("p", null,
                game && game.percentage
                    ? Math.ceil(+game.percentage.toFixed(2) * 100)
                    : 0,
                "%"),
            React.createElement("p", null, "\u0422\u043E\u0447\u043D\u043E\u0441\u0442\u044C")),
        React.createElement("div", { className: classes.rows },
            React.createElement("p", null, game ? game.biggestStreak : 0),
            React.createElement("p", null, "\u041B\u0443\u0447\u0448\u0430\u044F \u0441\u0435\u0440\u0438\u044F"))));
};
export default GameStat;
